// Вкладки каталога курсов. id совпадает с MainCategory на бэкенде.
// grouped: курсы вкладки выводятся блоками по категории (программе) и курсу обучения (studyYear).
export const CATALOG_TABS = [
    {
        id: '1',
        title: 'Сетевые образовательные программы повышения квалификации (ДПО) МИИГАиК',
        grouped: false
    },
    {
        id: '2',
        title: 'Программа магистратуры',
        grouped: true,
        badge: 'Магистратура'
    },
]

export function findTab(tabId) {
    return CATALOG_TABS.find(tab => tab.id === String(tabId))
}

export function isCourseInTab(course, tabId) {
    return (course.mainCategories || []).some(category => category.id === parseInt(tabId))
}
